import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const SearchIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M13.7331903,41.1797099 C6.16549133,33.612011 6.16549133,21.299917 13.7331903,13.7333292 C21.2997781,6.16563022 33.6129832,6.16563022 41.179571,13.7322181 C48.7461589,21.299917 48.7461589,33.612011 41.179571,41.1797099 C33.6118721,48.7474089 21.2997781,48.7462978 13.7331903,41.1797099 M46.8806228,8.03227745 C36.1696232,-2.67761099 18.7431381,-2.67761099 8.03324965,8.03338855 C-2.67774988,18.743277 -2.67774988,36.1697621 8.03324965,46.8796506 C17.7753704,56.6206602 33.0718777,57.4995399 43.8184324,49.518512 L50.6494724,56.3495519 C49.5494839,59.5750739 50.2694764,63.2983684 52.8305608,65.8583418 L64.2837748,77.3126669 C67.8670708,80.8948518 73.729232,80.8948518 77.312528,77.3126669 C80.895824,73.7293709 80.895824,67.8660986 77.312528,64.2828026 L65.859314,52.8295886 C63.2982295,50.2685042 59.574935,49.5485117 56.3483019,50.6496113 L49.5183731,43.8185713 C57.499401,33.0720166 56.6216324,17.7743982 46.8806228,8.03227745"
      />
    </Icon>
  );
};

SearchIcon.propTypes = {
  fill: PropTypes.string,
};

export default SearchIcon;
